import React from 'react';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import useGetSBSMonitoring from 'hooks/Reports/SBSMonitoring/SBSMonitoring';

import '../../Reports/SBSMonitoring/SBSMonitoring.scss';

interface InnerSbsMonitoringProps {
  slug: string;
  startDate: string;
  endDate: string;
  filterType: string;
}

const InnerSbsMonitoring: React.FC<InnerSbsMonitoringProps> = ({ slug, startDate, endDate, filterType }) => {
  const { data } = useGetSBSMonitoring(slug, startDate, endDate, filterType);
  const { t } = useTranslation();

  const allSignalDatesNull =
    data &&
    data.length > 0 &&
    data.every(trap => trap.signals.length === 0 || trap.signals.every(signal => signal.date == null));

  return (
    <div className="row mb-5">
      <h5 className="text-center">{t('VisitReportsPDF.header.SRBMMonitoring')}</h5>
      {allSignalDatesNull && (
        <div className="text-center text-success mb-2">
          {t('VisitReportsPDF.header.noMiceDuringPeriod', { startDate: startDate, endDate: endDate })}
        </div>
      )}
      <table className="w-100">
        <thead className="">
          <tr className="ml-th-bordered-bottom-dark">
            <th className="text-center sbs-th" scope="col">
              {t('MonitoringBait.chieldAccordion.sequenceNumber')}
            </th>
            <th className="text-center sbs-th" scope="col">
              {t('MonitoringBait.chieldAccordion.usedRodenticide')}
            </th>
            <th className="text-center sbs-th" scope="col">
              {t('VisitReportsPDF.monitoring-bait-table.signalDate')}
            </th>
            <th className="text-center sbs-th" scope="col">
              {t('VisitReportsPDF.monitoring-bait-table.signalTime')}
            </th>
            <th className="text-center sbs-th" scope="col">
              {t('VisitReportsPDF.monitoring-bait-table.RodenticideAmount')}
            </th>
            <th className="text-center sbs-th" scope="col">
              {t('VisitReportsPDF.monitoring-bait-table.eaten')}
            </th>
            <th className="text-center sbs-th" scope="col">
              {t('VisitReportsPDF.monitoring-bait-table.added')}
            </th>
          </tr>
        </thead>
        <tbody className="sbs-tbody">
          {data && data.length > 0 ? (
            data.map(trapMonitroingData =>
              trapMonitroingData.signals.length > 0 ? (
                trapMonitroingData.signals.map((signal, signalIndex) =>
                  signal.time.map((time, timeIndex) => (
                    <tr
                      className=""
                      key={`${trapMonitroingData.sequence_number}-${trapMonitroingData.date_of_installation}-${signal.date}-${timeIndex}`}
                    >
                      {signalIndex === 0 && timeIndex === 0 && (
                        <>
                          <td
                            className="text-center align-top sbs-td"
                            rowSpan={trapMonitroingData.signals.reduce((acc, cur) => acc + cur.time.length, 0)}
                          >
                            <div className="sticky-cell">{trapMonitroingData.sequence_number || 'N/A'}</div>
                          </td>
                          <td
                            className="text-center align-top sbs-td"
                            rowSpan={trapMonitroingData.signals.reduce((acc, cur) => acc + cur.time.length, 0)}
                          >
                            <div className="sticky-cell">{trapMonitroingData.used_poison || '---'}</div>
                          </td>
                        </>
                      )}
                      {timeIndex === 0 && (
                        <td className="text-center align-top sbs-td signal-date" rowSpan={signal.time.length}>
                          <div className="sticky-cell">{dayjs(signal.date).format('YYYY-DD-MM') || '---'}</div>
                        </td>
                      )}
                      <td className="text-center align-top sbs-td signal-time">{time.inner_time}</td>
                      <td className="text-center align-top sbs-td">{time.bait_filling || '---'}</td>
                      <td className={`text-center align-top sbs-td ${+time.eaten_bait === 0 ? '' : 'text-danger'}`}>
                        {+time.eaten_bait > 0 ? '-' : ''}
                        {Number(time.eaten_bait).toFixed(1)}
                      </td>
                      <td className={`text-center align-top sbs-td ${+time.added_bait === 0 ? '' : 'text-success'}`}>
                        <div className="d-flex justify-content-center align-items-center">
                          {+time.added_bait > 0 ? '+' : ''}
                          {Number(time.added_bait).toFixed(1)}
                          <div className="mx-2 d-felx">
                            {time.bait_replacement === true && (
                              <span title="Bait replacement" className="badge bg-warning">
                                R
                              </span>
                            )}
                          </div>
                        </div>
                      </td>
                    </tr>
                  )),
                )
              ) : (
                <tr>
                  <td className="text-center align-top sbs-td">{trapMonitroingData.sequence_number || 'N/A'}</td>
                  <td className="text-center align-top sbs-td">{trapMonitroingData.used_poison || 'N/A'}</td>
                  <td className="text-center align-top sbs-td">---</td>
                  <td className="text-center align-top sbs-td">---</td>
                  <td className="text-center align-top sbs-td">---</td>
                  <td className="text-center align-top sbs-td">---</td>
                  <td className="text-center align-top sbs-td">---</td>
                </tr>
              ),
            )
          ) : (
            <tr>
              <td colSpan={8} className="text-center align-top sbs-td text-success">
                {t('VisitReportsPDF.header.noMiceDuringPeriod', { startDate: startDate, endDate: endDate })}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default InnerSbsMonitoring;
